import { ChevronRight } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';

import { cx, focusRingClass } from './shared';

export interface BreadcrumbItem {
  label: string;
  /** Where the crumb leads. The last crumb is the current page and never links. */
  to?: string;
}

export interface BreadcrumbsProps {
  items: readonly BreadcrumbItem[];
  className?: string;
}

/** Where this page sits: "Devices › Pump 3 › History". The last item is the current page. */
export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  if (items.length === 0) return null;
  const lastIndex = items.length - 1;

  return (
    <nav aria-label="Breadcrumb" className={cx('min-w-0', className)}>
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-0.5 text-control">
        {items.map((item, index) => (
          <li key={`${index}-${item.label}`} className="flex min-w-0 items-center gap-1">
            {index > 0 ? (
              <ChevronRight className="h-4 w-4 shrink-0 text-ink-muted" aria-hidden="true" />
            ) : null}
            {index === lastIndex || !item.to ? (
              <span
                aria-current={index === lastIndex ? 'page' : undefined}
                className="break-words py-1 font-semibold text-ink-strong"
              >
                {item.label}
              </span>
            ) : (
              <RouterLink
                to={item.to}
                className={cx(
                  focusRingClass,
                  'break-words rounded-control py-1 font-semibold text-accent-ink underline-offset-2 hover:underline',
                )}
              >
                {item.label}
              </RouterLink>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
